import { render } from "./Home.vue?vue&type=template&id=8342fa70"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=8342fa70&lang=css"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__